function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import throttle from 'lodash/throttle.js';
import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import ServiceWorkerStore from "./ServiceWorkerStore.js";
import IndexedDBStore from "./IndexedDBStore.js";
import MetaDataStore from "./MetaDataStore.js";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.2.0"
};
var defaultOptions = {
  expires: 24 * 60 * 60 * 1000,
  // 24 hours
  serviceWorker: false
};
/**
 * The GoldenRetriever plugin — restores selected files and resumes uploads
 * after a closed tab or a browser crash!
 *
 * Uses localStorage, IndexedDB and ServiceWorker to do its magic, read more:
 * https://uppy.io/blog/2017/07/golden-retriever/
 */
var GoldenRetriever = /*#__PURE__*/function (_BasePlugin) {
  _inherits(GoldenRetriever, _BasePlugin);
  function GoldenRetriever(uppy, opts) {
    var _this;
    _classCallCheck(this, GoldenRetriever);
    _this = _callSuper(this, GoldenRetriever, [uppy, _objectSpread(_objectSpread({}, defaultOptions), opts)]);
    _this.addBlobToStores = function (file) {
      if (file.isRemote) return;
      if (_this.ServiceWorkerStore) {
        _this.ServiceWorkerStore.put(file).catch(function (err) {
          _this.uppy.log('[GoldenRetriever] Could not store file', 'warning');
          _this.uppy.log(err);
        });
      }
      _this.IndexedDBStore.put(file).catch(function (err) {
        _this.uppy.log('[GoldenRetriever] Could not store file', 'warning');
        _this.uppy.log(err);
      });
    };
    _this.removeBlobFromStores = function (file) {
      if (_this.ServiceWorkerStore) {
        _this.ServiceWorkerStore.delete(file.id).catch(function (err) {
          _this.uppy.log('[GoldenRetriever] Failed to remove file', 'warning');
          _this.uppy.log(err);
        });
      }
      _this.IndexedDBStore.delete(file.id).catch(function (err) {
        _this.uppy.log('[GoldenRetriever] Failed to remove file', 'warning');
        _this.uppy.log(err);
      });
    };
    _this.replaceBlobInStores = function (file) {
      _this.removeBlobFromStores(file);
      _this.addBlobToStores(file);
    };
    _this.handleRestoreConfirmed = function () {
      _this.uppy.log('[GoldenRetriever] Restore confirmed, proceeding...');
      // start all uploads again when file blobs are restored
      var _this$uppy$getState = _this.uppy.getState(),
        currentUploads = _this$uppy$getState.currentUploads;
      if (currentUploads) {
        _this.uppy.resumeAll();
        Object.keys(currentUploads).forEach(function (uploadId) {
          _this.uppy.restore(uploadId);
        });
      }
      _this.uppy.setState({
        recoveredState: null
      });
    };
    _this.abortRestore = function () {
      _this.uppy.log('[GoldenRetriever] Aborting restore...');
      var fileIDs = Object.keys(_this.uppy.getState().files);
      _this.deleteBlobs(fileIDs).then(function () {
        _this.uppy.log("[GoldenRetriever] Removed ".concat(fileIDs.length, " files"));
      }).catch(function (err) {
        _this.uppy.log("[GoldenRetriever] Could not remove ".concat(fileIDs.length, " files"), 'warning');
        _this.uppy.log(err);
      });
      _this.uppy.cancelAll();
      _this.uppy.setState({
        recoveredState: null
      });
      MetaDataStore.cleanup(_this.uppy.opts.id);
    };
    _this.handleComplete = function (_ref) {
      var successful = _ref.successful;
      var fileIDs = successful.map(function (file) {
        return file.id;
      });
      _this.deleteBlobs(fileIDs).then(function () {
        _this.uppy.log("[GoldenRetriever] Removed ".concat(successful.length, " files that finished uploading"));
      }).catch(function (err) {
        _this.uppy.log("[GoldenRetriever] Could not remove ".concat(successful.length, " files that finished uploading"), 'warning');
        _this.uppy.log(err);
      });
      _this.uppy.setState({
        recoveredState: null
      });
      MetaDataStore.cleanup(_this.uppy.opts.id);
    };
    _this.restoreBlobs = function () {
      if (_this.uppy.getFiles().length > 0) {
        Promise.all([_this.loadFileBlobsFromServiceWorker(), _this.loadFileBlobsFromIndexedDB()]).then(function (resultingArrayOfObjects) {
          var blobs = _objectSpread(_objectSpread({}, resultingArrayOfObjects[0]), resultingArrayOfObjects[1]);
          _this.onBlobsLoaded(blobs);
        });
      } else {
        _this.uppy.log('[GoldenRetriever] No files need to be loaded, only restoring processing state...');
      }
    };
    _this.type = 'debugger';
    _this.id = _this.opts.id || 'GoldenRetriever';
    _this.MetaDataStore = new MetaDataStore({
      expires: _this.opts.expires,
      storeName: uppy.getID()
    });
    _this.ServiceWorkerStore = null;
    if (_this.opts.serviceWorker) {
      _this.ServiceWorkerStore = new ServiceWorkerStore({
        storeName: uppy.getID()
      });
    }
    _this.IndexedDBStore = new IndexedDBStore(_objectSpread(_objectSpread({
      expires: _this.opts.expires
    }, _this.opts.indexedDB || {}), {}, {
      storeName: uppy.getID()
    }));
    _this.saveFilesStateToLocalStorage = throttle(_this.saveFilesStateToLocalStorage.bind(_assertThisInitialized(_this)), 500, {
      leading: true,
      trailing: true
    });
    _this.restoreState = _this.restoreState.bind(_assertThisInitialized(_this));
    _this.loadFileBlobsFromServiceWorker = _this.loadFileBlobsFromServiceWorker.bind(_assertThisInitialized(_this));
    _this.loadFileBlobsFromIndexedDB = _this.loadFileBlobsFromIndexedDB.bind(_assertThisInitialized(_this));
    _this.onBlobsLoaded = _this.onBlobsLoaded.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(GoldenRetriever, [{
    key: "restoreState",
    value: function restoreState() {
      var savedState = this.MetaDataStore.load();
      if (savedState) {
        this.uppy.log('[GoldenRetriever] Recovered some state from Local Storage');
        this.uppy.setState({
          currentUploads: savedState.currentUploads || {},
          files: savedState.files || {},
          recoveredState: savedState
        });
        this.savedPluginData = savedState.pluginData;
      }
    }

    /**
     * Get file objects that are currently waiting: they've been selected,
     * but aren't yet being uploaded.
     */
  }, {
    key: "getWaitingFiles",
    value: function getWaitingFiles() {
      var waitingFiles = {};
      this.uppy.getFiles().forEach(function (file) {
        if (!file.progress || !file.progress.uploadStarted) {
          waitingFiles[file.id] = file;
        }
      });
      return waitingFiles;
    }

    /**
     * Get file objects that are currently being uploaded. If a file has finished
     * uploading, but the other files in the same batch have not, the finished
     * file is also returned.
     */
  }, {
    key: "getUploadingFiles",
    value: function getUploadingFiles() {
      var _this2 = this;
      var uploadingFiles = {};
      var _this$uppy$getState2 = this.uppy.getState(),
        currentUploads = _this$uppy$getState2.currentUploads;
      if (currentUploads) {
        var uploadIDs = Object.keys(currentUploads);
        uploadIDs.forEach(function (uploadID) {
          var filesInUpload = currentUploads[uploadID].fileIDs;
          filesInUpload.forEach(function (fileID) {
            uploadingFiles[fileID] = _this2.uppy.getFile(fileID);
          });
        });
      }
      return uploadingFiles;
    }
  }, {
    key: "saveFilesStateToLocalStorage",
    value: function saveFilesStateToLocalStorage() {
      var filesToSave = _objectSpread(_objectSpread({}, this.getWaitingFiles()), this.getUploadingFiles());
      var fileToSaveEntries = Object.entries(filesToSave);

      // If all files have been removed by the user, clear recovery state
      if (fileToSaveEntries.length === 0) {
        if (this.uppy.getState().recoveredState !== null) {
          this.uppy.setState({
            recoveredState: null
          });
        }
        MetaDataStore.cleanup(this.uppy.opts.id);
        return;
      }

      // We dont’t need to store file.data on local files, because the actual blob will be restored later,
      // and we want to avoid having weird properties in the serialized object.
      // Also adding file.isRestored to all files, since they will be restored from local storage
      var filesToSaveWithoutData = Object.fromEntries(fileToSaveEntries.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          id = _ref3[0],
          fileInfo = _ref3[1];
        return [id, fileInfo.isRemote ? _objectSpread(_objectSpread({}, fileInfo), {}, {
          isRestored: true
        }) : _objectSpread(_objectSpread({}, fileInfo), {}, {
          isRestored: true,
          data: null,
          preview: null
        })];
      }));
      var pluginData = {};
      // TODO Remove this,
      // Other plugins can attach a restore:get-data listener that receives this callback.
      // Plugins can then use this callback (sync) to provide data to be stored.
      this.uppy.emit('restore:get-data', function (data) {
        Object.assign(pluginData, data);
      });
      var _this$uppy$getState3 = this.uppy.getState(),
        currentUploads = _this$uppy$getState3.currentUploads;
      this.MetaDataStore.save({
        currentUploads: currentUploads,
        files: filesToSaveWithoutData,
        pluginData: pluginData
      });
    }
  }, {
    key: "loadFileBlobsFromServiceWorker",
    value: function loadFileBlobsFromServiceWorker() {
      var _this3 = this;
      if (!this.ServiceWorkerStore) {
        return Promise.resolve({});
      }
      return this.ServiceWorkerStore.list().then(function (blobs) {
        var numberOfFilesRecovered = Object.keys(blobs).length;
        if (numberOfFilesRecovered > 0) {
          _this3.uppy.log("[GoldenRetriever] Successfully recovered ".concat(numberOfFilesRecovered, " blobs from Service Worker!"));
          return blobs;
        }
        _this3.uppy.log('[GoldenRetriever] No blobs found in Service Worker, trying IndexedDB now...');
        return {};
      }).catch(function (err) {
        _this3.uppy.log('[GoldenRetriever] Failed to recover blobs from Service Worker', 'warning');
        _this3.uppy.log(err);
        return {};
      });
    }
  }, {
    key: "loadFileBlobsFromIndexedDB",
    value: function loadFileBlobsFromIndexedDB() {
      var _this4 = this;
      return this.IndexedDBStore.list().then(function (blobs) {
        var numberOfFilesRecovered = Object.keys(blobs).length;
        if (numberOfFilesRecovered > 0) {
          _this4.uppy.log("[GoldenRetriever] Successfully recovered ".concat(numberOfFilesRecovered, " blobs from IndexedDB!"));
          return blobs;
        }
        _this4.uppy.log('[GoldenRetriever] No blobs found in IndexedDB');
        return {};
      }).catch(function (err) {
        _this4.uppy.log('[GoldenRetriever] Failed to recover blobs from IndexedDB', 'warning');
        _this4.uppy.log(err);
        return {};
      });
    }
  }, {
    key: "onBlobsLoaded",
    value: function onBlobsLoaded(blobs) {
      var _this5 = this;
      var obsoleteBlobs = [];
      var updatedFiles = _objectSpread({}, this.uppy.getState().files);

      // Loop through blobs that we can restore, add blobs to file objects
      Object.keys(blobs).forEach(function (fileID) {
        var originalFile = _this5.uppy.getFile(fileID);
        if (!originalFile) {
          obsoleteBlobs.push(fileID);
          return;
        }
        var cachedData = blobs[fileID];
        var updatedFileData = {
          data: cachedData,
          isRestored: true,
          isGhost: false
        };
        updatedFiles[fileID] = _objectSpread(_objectSpread({}, originalFile), updatedFileData);
      });

      // Loop through files that we can’t restore fully — we only have meta, not blobs,
      // set .isGhost on them, also set isRestored to all files
      Object.keys(updatedFiles).forEach(function (fileID) {
        if (updatedFiles[fileID].data === null) {
          updatedFiles[fileID] = _objectSpread(_objectSpread({}, updatedFiles[fileID]), {}, {
            isGhost: true
          });
        }
      });
      this.uppy.setState({
        files: updatedFiles
      });
      this.uppy.emit('restored', this.savedPluginData);
      if (obsoleteBlobs.length) {
        this.deleteBlobs(obsoleteBlobs).then(function () {
          _this5.uppy.log("[GoldenRetriever] Cleaned up ".concat(obsoleteBlobs.length, " old files"));
        }).catch(function (err) {
          _this5.uppy.log("[GoldenRetriever] Could not clean up ".concat(obsoleteBlobs.length, " old files"), 'warning');
          _this5.uppy.log(err);
        });
      }
    }
  }, {
    key: "deleteBlobs",
    value: function () {
      var _deleteBlobs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileIDs) {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all(fileIDs.map(function (id) {
                var _this$ServiceWorkerSt, _this$ServiceWorkerSt2, _this$IndexedDBStore;
                return (_this$ServiceWorkerSt = (_this$ServiceWorkerSt2 = _this6.ServiceWorkerStore) == null ? void 0 : _this$ServiceWorkerSt2.delete(id)) != null ? _this$ServiceWorkerSt : (_this$IndexedDBStore = _this6.IndexedDBStore) == null ? void 0 : _this$IndexedDBStore.delete(id);
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function deleteBlobs(_x) {
        return _deleteBlobs.apply(this, arguments);
      }
      return deleteBlobs;
    }()
  }, {
    key: "install",
    value: function install() {
      this.restoreState();
      this.restoreBlobs();
      this.uppy.on('file-added', this.addBlobToStores);
      // @ts-expect-error this is typed in @uppy/image-editor and we can't access those types.
      this.uppy.on('file-editor:complete', this.replaceBlobInStores);
      this.uppy.on('file-removed', this.removeBlobFromStores);
      // TODO: the `state-update` is bad practise. It fires on any state change in Uppy
      // or any state change in any of the plugins. We should to able to only listen
      // for the state changes we need, somehow.
      this.uppy.on('state-update', this.saveFilesStateToLocalStorage);
      this.uppy.on('restore-confirmed', this.handleRestoreConfirmed);
      this.uppy.on('restore-canceled', this.abortRestore);
      this.uppy.on('complete', this.handleComplete);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.off('file-added', this.addBlobToStores);
      // @ts-expect-error this is typed in @uppy/image-editor and we can't access those types.
      this.uppy.off('file-editor:complete', this.replaceBlobInStores);
      this.uppy.off('file-removed', this.removeBlobFromStores);
      this.uppy.off('state-update', this.saveFilesStateToLocalStorage);
      this.uppy.off('restore-confirmed', this.handleRestoreConfirmed);
      this.uppy.off('restore-canceled', this.abortRestore);
      this.uppy.off('complete', this.handleComplete);
    }
  }]);
  return GoldenRetriever;
}(BasePlugin);
export { GoldenRetriever as default };
GoldenRetriever.VERSION = packageJson.version;